import { render } from "./FriendCard.vue?vue&type=template&id=0e286a1e&scoped=true"
import script from "./FriendCard.vue?vue&type=script&lang=js"
export * from "./FriendCard.vue?vue&type=script&lang=js"

import "./FriendCard.vue?vue&type=style&index=0&id=0e286a1e&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e286a1e"]])

export default __exports__